import React from "react";

import ptBr from "../../../config/texts/pt-br";
import {
  ButtonText,
  CustomText,
  Input,
  InputAutocomplete,
  InputDate,
} from "../../../components/index";
import Styles from "../styles";
import { FormFull } from "form-full";
import { hooks, masks } from "../../../utils";

import { fonts, Spacing, SVG } from "../../../config";
import { Grid, Button } from "@material-ui/core";
import { customModal } from "../../../components/modals/utils";
import { Visibility } from "@material-ui/icons";
import VisibilityIcon from '@material-ui/icons/Visibility';
import { api } from "../../../services";
import ModalImage from "./ModalImage";
import { ModalViewQRCode } from "./ModalViewQRCode";
import { ThemeProvider, createTheme } from "@material-ui/core";
import { ButtonMenu } from "../../../components/index";

function ModalView({ onSubmit, item }) {
  const texts = ptBr.login;
  const { call } = hooks.useRequest();
  const [ QRCodeUrl, setQRCodeUrl ] = React.useState('');
  const [viewPasswords, setViewPasswords] = React.useState(false);

  const theme = createTheme({
    palette: {
      primary: {
        main: "#FFFFFF",
      },
    },
  });

  function getButtons(itemGuest, fullItem) {

    if (itemGuest.imageId == null || itemGuest.imageId == undefined) {
      return [{
        label: "Link ",
        onClick: () => customModal.setInfos(
          "Link da Imagem",
          [itemGuest.facialUrl],
          {
            onClick: () => {
              customModal.close();
              openModalView(fullItem);
            },
            label: "Voltar",
          },
          null,
          null,
          false,
          true,
          <Visibility />
        )
      }]
    } else {
      return [
      {
        label: "Link ",
        onClick: () => {
          customModal.setInfos(
            "Link da Imagem",
            [itemGuest.facialUrl],
            {
              onClick: () => {
                customModal.close();
                openModalView(fullItem);
              },
              label: "Voltar",
            },
            null,
            null,
            false,
            true,
            <Visibility />
          )
        },
      },
      {
        label: "Imagem",
        onClick: () => {
          openModalViewImg(fullItem, itemGuest);
        },
      },
    ];
    }
    
  } 

  const drawMembers = (number: number) => {
    const membersForm: any = [];

    for (let index = 0; index < number; index++) {
      const [viewPasswordsSecondary, setViewPasswordsSecondary] = React.useState(false);
      membersForm.push(
        <>
          <CustomText
            fontFamily={fonts.bold}
            fontSize={14 / 8}
            textColor="#B2B2B2"
            style={{ paddingTop: "25px" }}
          >
            ACOMPANHANTE #{index + 1}
          </CustomText>
          <Grid alignItems="flex-end" container spacing={1}>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Nome Completo</Styles.Label>
              <Styles.Value>{item?.secondaryGuests[index]?.name}</Styles.Value>
            </Grid>{" "}
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Documento</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.document
                  ? masks.CPF(item?.secondaryGuests[index]?.document)
                  : item?.secondaryGuests[index]?.passport}
              </Styles.Value>
            </Grid> */}
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>DATA NASCIMENTO</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.birthDate &&
                  masks.formatDate(item?.secondaryGuests[index].birthDate)}
              </Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>E-Mail</Styles.Label>
              <Styles.Value>{item?.secondaryGuests[index]?.email}</Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Telefone</Styles.Label>
              <Styles.Value>
                {masks.inputMaskTELWithDDD(item?.secondaryGuests[index]?.phone)}
              </Styles.Value>
            </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>Placa do veículo</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.vehiclePlate}
              </Styles.Value>
            </Grid> */}
            <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>ASSINATURA FACIAL</Styles.Label>
              <Styles.Value>
                {item?.secondaryGuests[index]?.imageId
                  ? "doc-facial.png"
                  : "Sem Imagem"}
                {/* <Styles.ValueSpan
                  $disabled={
                    item?.secondaryGuests[index]?.imageId === null ||
                    item?.secondaryGuests[index]?.imageId === undefined
                  }
                  onClick={() => {
                    if (
                      item?.secondaryGuests[index]?.imageId !== null ||
                      item?.secondaryGuests[index]?.imageId === undefined
                    ) {
                      openModalViewImg(item, item?.secondaryGuests[index]);
                      // downloadImage(item?.secondaryGuests[index]?.imageId);
                    }
                  }}
                >
                  Visualizar <Visibility />
                </Styles.ValueSpan> */}
                { item.secondaryGuests[index]?.imageId ?
                  <ButtonMenu
                    endIcon={<Visibility />}
                    buttons={getButtons(item?.secondaryGuests[index], item)}
                  >
                    Vizualizar
                  </ButtonMenu> :
                  null
                  }
              </Styles.Value>
            </Grid>
            <Grid item xs={12} md={6} lg={3} >
            <Styles.Label>Senhas</Styles.Label>
            { item?.secondaryGuests[index]?.passwords.length == 0 || item?.secondaryGuests[index]?.passwords == null ? <Styles.Value> Senhas não geradas </Styles.Value> :
              <Styles.Value>
                {viewPasswordsSecondary ? item?.secondaryGuests[index]?.passwords.join(", ") : masks.passwords(item?.secondaryGuests[index]?.passwords)}  
                <Button onClick={() => setViewPasswordsSecondary(!viewPasswordsSecondary)} disableRipple size="small" style={{ padding: 0 , marginTop: 0 }} >
                  <ThemeProvider theme={theme}>
                    <VisibilityIcon color="primary"/>
                  </ThemeProvider>
                </Button>
              </Styles.Value>
            }
          </Grid>
            {/* <Grid item xs={12} md={6} lg={3}>
              <Styles.Label>QR Code</Styles.Label>
                <Styles.Value>
                  <Styles.ValueSpan
                    onClick={() => {
                        openModalViewImg(item, item?.secondaryGuests[index]);
                    }}
                  >
                    Gerar QR Code <Visibility />
                  </Styles.ValueSpan>
                </Styles.Value>
            </Grid> */}
          </Grid>
        </>
      );
    }
    return membersForm;
  };

  const openModalViewImg = (fullItem, imageData) => {
    customModal.setInfos(
      "doc-facial.png",
      [],
      {
        onClick: () => {
          customModal.close();
          openModalView(fullItem);
        },
        label: "Voltar",
      },
      null,
      <ModalImage item={imageData} />,
      false,
      true,
      null
    );
  };

  const openModalView = (item) => {
    customModal.setInfos(
      "Cadastrar Reserva",
      [],
      {
        onClick: () => {
          customModal.close();
        },
        label: "Voltar",
      },
      null,
      <ModalView item={item} onSubmit={(value) => console.log(value)} />,
      false,
      true,
      <SVG.File />
    );
  };

  function QrCodeModals() {
    customModal.setInfos(
      "Alerta QR Code",
      [
        "Gerar QR Code para acesso do Hóspede? Caso esse hospede já possua um QR Code, seu código antigo será invalidado."
      ],
      {
        onClick: () => {
          customModal.close();
          call(null, api.getQRCode(item.id), (response) => {
            if (response.ok) {
              customModal.setInfos(
                "Vizualizar QR Code",
                [],
                {
                  onClick: () => {
                    customModal.close();
                  },
                  label: "Voltar",
                },
                null,
                <ModalViewQRCode qrCodeUrl={response?.data} />,
                false,
                true,
                <Visibility />
              );
            } else {
              console.log("Erro ao gerar QR Code");
              console.log(response);
              console.log(response.data);
              customModal.close();
            }
          });
        },
        label: "Gerar QR Code",
      },
      null,
      null,
      false,
      false,
      null,
    )
  }
  
  return (
    <>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          minWidth: "clamp(300px, 54vw, 1055px)",
          paddingInline: "25px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",

            padding: "24px",
            backgroundColor: "#383B3E",
            overflow: "auto",
            maxHeight: "430px",
            borderRadius: "5px",
          }}
        >
          <FormFull
            onSubmit={(data) => {
              onSubmit(data);
            }}
          >
            <CustomText
              fontFamily={fonts.bold}
              fontSize={14 / 8}
              textColor="#B2B2B2"
            >
              LOCATÁRIO PRIMÁRIO
            </CustomText>
            <Grid alignItems="flex-end" container spacing={1}>
              {" "}
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>Nome Completo</Styles.Label>
                <Styles.Value>{item?.primaryGuest?.name}</Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>Documento</Styles.Label>
                <Styles.Value>
                  {item?.primaryGuest?.document
                    ? masks.CPF(item?.primaryGuest?.document)
                    : item?.primaryGuest?.passport}
                </Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>DATA NASCIMENTO</Styles.Label>
                <Styles.Value>
                  {" "}
                  {item?.primaryGuest?.birthDate
                    ? masks.formatDate(item?.primaryGuest?.birthDate)
                    : "-"}
                </Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>E-Mail</Styles.Label>
                <Styles.Value>{item?.primaryGuest?.email}</Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>Telefone</Styles.Label>
                <Styles.Value>
                  {masks.inputMaskTELWithDDD(item?.primaryGuest?.phone)}
                </Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>Placa do veículo</Styles.Label>
                <Styles.Value>
                  {item?.primaryGuest?.vehiclePlate}
                </Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>ASSINATURA FACIAL</Styles.Label>
                <Styles.Value>
                  {item.primaryGuest.imageId ? "doc-facial.png" : "Sem Imagem"}
                  {/* <Styles.ValueSpan
                    $disabled={
                      item.primaryGuest.imageId === null &&
                      item.primaryGuest.imageId !== undefined
                    }
                    onClick={() => {
                      if (
                        item.primaryGuest.imageId !== null &&
                        item.primaryGuest.imageId !== undefined
                      ) {
                        openModalViewImg(item, item.primaryGuest);
                        // downloadImage(item.primaryGuest.imageId);
                      }
                    }}
                  >
                    Visualizar <Visibility />
                  </Styles.ValueSpan> */}
                  { item.primaryGuest.imageId ?
                    <ButtonMenu
                      endIcon={<Visibility />}
                      buttons={getButtons(item?.primaryGuest, item)}
                    >
                      Vizualizar
                    </ButtonMenu> :
                    <ButtonMenu
                      endIcon={<Visibility />}
                      buttons={getButtons(item?.primaryGuest, item)}
                    >
                        Tirar Foto
                    </ButtonMenu>
                  }
                </Styles.Value>
              </Grid>
              <Grid item xs={12} md={6} lg={3} >
                <Styles.Label>Senhas</Styles.Label>
                { item?.primaryGuest?.passwords.length === 0 ? <Styles.Value> Senhas não geradas </Styles.Value> :
                  <Styles.Value>
                  {viewPasswords ? item?.primaryGuest?.passwords.join(", ") : masks.passwords(item?.primaryGuest?.passwords)}  
                  <Button onClick={() => setViewPasswords(!viewPasswords)} disableRipple size="small" style={{ padding: 0 , marginTop: 0 }} >
                    <ThemeProvider theme={theme}>
                      <VisibilityIcon color="primary"/>
                    </ThemeProvider>
                  </Button>
                </Styles.Value>}
              </Grid>
              {/* <Grid item xs={12} md={6} lg={3}>
                <Styles.Label>QR Code</Styles.Label>
                  <Styles.Value>
                    <Styles.ValueSpan
                      onClick={() => {
                        QrCodeModals();
                      }}
                    >
                      Gerar QR Code <Visibility />
                    </Styles.ValueSpan>
                  </Styles.Value>
              </Grid> */}
            </Grid>
            {drawMembers(item.numGuests)}
          </FormFull>
        </div>
      </div>
    </>
  );
}

export default ModalView;
